var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',{attrs:{"width":_vm.dimensions.width,"height":_vm.dimensions.height}},[_c('rect',{attrs:{"width":_vm.dimensions.width,"height":_vm.dimensions.height,"fill":"black"}})])}
var staticRenderFns = []

export { render, staticRenderFns }